import useGlobals from './useGlobals';
import { userService } from '../Services/userService';

const useUsers = () => {
    const { handleNavigate, i18n, demo, windowWidth, getBreakpoint } = useGlobals();

    return {
        handleNavigate,
        i18n,
        windowWidth,
        getBreakpoint,
        userService,
        demo,
    };
};

export default useUsers;
